import React from 'react';
import Icon from '../../../components/AppIcon';

const CommunicationWorkflow = () => {
  const touchpoints = [
    {
      icon: "Calendar",
      title: "Weekly Sprint Reviews",
      description: "Scheduled video calls to review progress, demonstrate completed features, and gather feedback on deliverables.",
      frequency: "Every Monday & Thursday"
    },
    {
      icon: "MessageSquare",
      title: "Daily Async Updates",
      description: "Written progress reports via Slack or email covering completed tasks, blockers, and next steps for transparency.",
      frequency: "Every business day"
    },
    {
      icon: "GitBranch",
      title: "Code Review Sessions",
      description: "Collaborative code walkthroughs where technical stakeholders can review implementation details and architecture decisions.",
      frequency: "Bi-weekly"
    },
    {
      icon: "FileText",
      title: "Documentation Delivery",
      description: "Comprehensive technical documentation, API references, and user guides delivered at each milestone completion.",
      frequency: "Per milestone"
    },
    {
      icon: "AlertCircle",
      title: "Issue Escalation Protocol",
      description: "Immediate notification system for critical blockers or scope changes requiring urgent client decision-making.",
      frequency: "As needed"
    },
    {
      icon: "BarChart3",
      title: "Monthly Business Reviews",
      description: "Strategic alignment meetings discussing project health, budget tracking, timeline adjustments, and success metrics.",
      frequency: "Monthly"
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 md:p-8 lg:p-10">
      <div className="mb-6 md:mb-8 lg:mb-10">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-headline font-semibold text-foreground mb-3 md:mb-4">
          Client Communication Workflow
        </h3>
        <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
          Structured touchpoints ensuring transparency, alignment, and collaborative decision-making throughout your project journey.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {touchpoints?.map((touchpoint, index) => (
          <div 
            key={index}
            className="bg-background border border-border rounded-lg p-4 md:p-6 hover:border-primary transition-all duration-300 hover:shadow-md"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-3 md:mb-4">
              <Icon name={touchpoint?.icon} size={24} color="var(--color-primary)" />
            </div>
            <h4 className="text-base md:text-lg font-semibold text-foreground mb-2">
              {touchpoint?.title}
            </h4>
            <p className="text-sm md:text-base text-muted-foreground mb-3 md:mb-4 leading-relaxed">
              {touchpoint?.description}
            </p>
            <div className="flex items-center gap-2 text-xs md:text-sm text-primary font-medium">
              <Icon name="Clock" size={16} />
              <span>{touchpoint?.frequency}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommunicationWorkflow;